<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { Toaster } from "vue-sonner";

import PwaUpdateDialog from "@/components/pwa-update-dialog";
import { useFlash } from "@/hooks/use-flash";
import { rootPath, signInPath, signUpPath } from "@/routes";

useFlash();
</script>

<template>
  <div class="mx-auto flex min-h-[100dvh] max-w-7xl flex-col bg-background text-foreground">
    <header class="border-b border-border/70 bg-background/90 pt-[env(safe-area-inset-top)] backdrop-blur">
      <div class="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-2.5 sm:px-6 sm:py-3">
        <Link :href="rootPath()" class="text-base font-semibold tracking-tight">Condor</Link>

        <nav class="flex items-center gap-2 text-sm">
          <Link :href="signInPath()" class="rounded-lg px-3 py-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground">Iniciar sesión</Link>
          <Link :href="signUpPath()" class="rounded-lg border px-3 py-2 font-medium transition-colors hover:bg-muted">Crear cuenta</Link>
        </nav>
      </div>
    </header>

    <main class="flex-1" style="view-transition-name: main-content">
      <slot />
    </main>

    <Toaster rich-colors position="top-center" />
    <PwaUpdateDialog />
  </div>
</template>
